import React, {memo, useCallback} from 'react';
import {ScenarioModel} from '../../store/control/state';
import {useDispatch} from 'react-redux';
import {toggleScenarioPopupScreenAction} from '../../store/ui/actions';
import {Column} from '../Column';
import {Widget} from '../Widget';
import {Button} from '../Button';
import scenarioIcon from '../../assets/images/icons/scenario/scenario.png';
import playingIcon from '../../assets/images/icons/scenario/scenario-playing.png';
import './scenario.scss';

export const Scenario = memo(function Scenario({scenario}: { scenario: ScenarioModel }) {
    const dispatch = useDispatch();
    const onClick = useCallback(() => {
        dispatch(toggleScenarioPopupScreenAction(scenario));
    }, [dispatch, scenario]);

    return (
        <Column min={3} max={6}>
            <Widget style={{padding: 0}}>
                <Button icon={scenario.icon_type || scenarioIcon} title={scenario.name} onClick={onClick}>
                    {
                        renderIf(scenario.is_playing)(() =>
                            <div className="scenario-icon playing">
                                <img src={playingIcon} alt=''/>
                            </div>,
                        )
                    }
                </Button>
            </Widget>
        </Column>
    );
});
